import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Form, Input, Select, Upload, message, DatePicker, Table, Space, Drawer, Modal, Spin } from 'antd';
import PropTypes from 'prop-types';
import ImgCrop from 'antd-img-crop';
import moment from 'moment';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { PlusCircleOutlined, InfoCircleOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import InitialData from './InitialData.json'
import PipelineStagesArrow from './DetailsPage/PipelineStages'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { AccountsByAccountType, FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { FetchDealByAccount, FetchAllPipeline, PriorityDealApi, DealTypeAPi, wonReasonApi, LostReasonApi, HoldReasonapi, createDeals } from '../../../Api/Services/DealApiService';
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService';
import { getAllUsersData, getBussinesDaysForStaffRole } from '../../../Api/Services/CommonApiService'
import { getProjectList, getProductDetails } from '../../../Api/Services/Productapiservice'
import { FetchAllServiceLines } from '../../../Api/Services/ServiceLineApiService'
import { findAllStaffRoleByReportingUser, getByAddStaffRoleId } from '../../../Api/Services/StaffRoleApiService'
// import { PageHeader } from '../../../components/page-headers/page-headers';
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled'
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { convertCurrency, ExchangeCurrency } from '../Filters/FilterConditions';
import { getAxiosInstance } from '../../../Api/ApiConfig'
import AllCancelPopup from '../Popup/AllCancelPopup';
import Data from '../MassupdateJson/InLineEditFields.json';
import { SaveIcon, CancelIcon } from '../../../components/Icons/Icons';
import { nameOnChangeValidator } from '../../../components/utilities/utilities'; // validateDescriptionField

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger }) {
    const scrollRef = useRef(null);
    const getFieldPopupContainer = (triggerNode) =>
        scrollRef.current?.view ||
        triggerNode.closest('.ant-drawer-content') ||
        triggerNode.closest('.ant-modal-content') ||
        document.body;
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const cloneLocalData = useSelector((state) => state.localRedux);
    const defaultCurrency = cloneLocalData.currency
    const ProfileData = cloneLocalData.profile
    const profile = ProfileData
    const permission = cloneLocalData.permissions
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const [form] = Form.useForm();
    const [users, setUsers] = useState([])
    const [dealInitial, setDealInitial] = useState()
    const [tempWinProp, setTempWinProp] = useState()
    const [edit, setEdit] = useState(false)
    const [editWon, setEditWon] = useState(false)
    const [account, setAccount] = useState([])
    const [accountbyType, setAccountbyType] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [dealPriority, setDealPriority] = useState([])
    const [dealType, setDealType] = useState([])
    const [dealWon, setDealWon] = useState([])
    const [dealLose, setDealLose] = useState([])
    const [dealOnHold, setDealOnHold] = useState([])
    const [pipeLineStage, setPipelineStage] = useState([])
    // const [companyId, setCompayId] = useState()
    const [editField, setEditField] = useState(false)
    const [pipelineData, setPipelineData] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [drawerPage, setDrawerPage] = useState()
    const [dealTypeData, setDealTypeData] = useState()
    const [dealTypeField, setDealTypeField] = useState()
    const [typeAction, setTypeAction] = useState()
    const [productdata, setProductdata] = useState([])
    const [contacts, setContacts] = useState([])
    const [imageUploading, setImageUploading] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [content1, setContent1] = React.useState();
    const [winProbability, setWinProbability] = useState()
    const [dealDiscount, setDealDiscount] = useState()
    const [serviceLineData, setServiceLineData] = useState([])
    const [inLineFields, setInLineFields] = useState(Data.Deals)
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const [revenueStartDate, setRevenueStartDate] = useState(null)
    const [revenueEndDate, setRevenueEndDate] = useState(null)
    const [actualclosureDate, setActualclosureDate] = useState(null)
    const [dealLostDate, setDealLostDate] = useState(null)
    const [dealonholdDate, setDealonholdDate] = useState(null)
    const [dealrestartDate, setDealrestartDate] = useState(null)
    const [dealValueEdit, setDealValueEdit] = useState()
    const [editableType, setEditableType] = useState(false)
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [image, setImage] = useState()
    const [deleteOption, setDeleteOpen] = useState(false);
    const [staffRoleData, setStaffRoleData] = useState([])
    const [permissions] = useState(permission.entity)
    const [dealValues, setDealValue] = useState(0)
    const [totalDeal, setTotalDeal] = useState(0)
    const [dataPermissions, setDataPermissions] = useState()
    const [dealMapList, setDealMapList] = useState([])
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const formattedCurrentDate = currentDate.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    // get linked data permission
    // Update/Delete
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            // subtotal: '',
            // adjustmentType: '%',
            // adjustments: '',
            total: '',
        },
    ]);
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value && value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value && value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        },
    ]);
    // const isroleDataValid = roleData.every(formData => {
    //     return Object.values(formData).every(value => value && value !== undefined && value !== '');
    // });
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            setAccountbyType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName?.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data;
            if (displayData?.account_id) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.account_name, account_id: displayData?.account_id, account_type_name: "Customer" }];
                }
            }
            if (FromPage === "ContactPage" && dataForDeal) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === dataForDeal?.contactDetails?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: dataForDeal?.contactDetails?.account_name, account_id: dataForDeal?.contactDetails?.account_id, account_type_name: "Customer", account_number: dataForDeal?.contactDetails?.account_number, account_profile: dataForDeal?.contactDetails?.account_profile }];
                }
            }
            // if (displayData?.competition && displayData?.competition !== "") {
            //     const competitionIds = displayData.competition.split(',').map(id => id.trim());
            //     const competitionData = displayData.competitiondata || [];

            //     competitionIds.forEach((competitionId, idx) => {
            //         const isCompAlreadyIncluded = accountInfo?.some(
            //             contact => contact.account_id === Number(competitionId)
            //         );

            //         if (!isCompAlreadyIncluded) {
            //             const competitionEntry = competitionData[idx];
            //             const competitionName = competitionEntry?.competitionName

            //             accountInfo = [
            //                 ...accountInfo,
            //                 {
            //                     account_name: competitionName,
            //                     account_id: Number(competitionId),
            //                     account_type_name: "Competitor"
            //                 }
            //             ];
            //         }
            //     });
            // }
            setAccount(accountInfo)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function PriorityApi() {
        try {
            const data = await PriorityDealApi()
            const options = data.map((option, i) => (
                <Option value={option.priorityId} key={i} >
                    {option.priorityName}
                </Option>));
            setDealPriority(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function DealTypeApi() {
        try {
            const data = await DealTypeAPi()
            setDealType(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealWonApi() {
        try {
            const data = await wonReasonApi()
            const options = data.map((option, i) => (
                <Option value={option.dealWonReasonId} key={i} >
                    {option.dealWonReasonName}
                </Option>));
            setDealWon(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealLoseApi() {
        try {
            const data = await LostReasonApi()
            const options = data.map((option, i) => (
                <Option value={option.dealLostReasonId} key={i} >
                    {option.dealLostReasonName}
                </Option>));
            setDealLose(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function DealOnHoldApi() {
        try {
            const data = await HoldReasonapi()
            const options = data.map((option, i) => (
                <Option value={option.dealHoldReasonId} key={i} >
                    {option.dealOnHoldReasonName}
                </Option>));
            setDealOnHold(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleEditFieldChange = (field) => {
        setInLineFields((prevValues) => ({
            ...prevValues,
            [field]: !prevValues[field],
        }));
    };
    const handlePipeLineChange = (value, option, winData) => {
        form.setFieldsValue({ pipelineStage: value })
        setPipelineData(value)
        setPipeLineField(option.key)
        if (option.key !== "Prospecting" && option.key !== "Qualification" && option.key !== "Discovery") {
            form.setFieldsValue({
                commitstatus: "Soft Commit"
            })
        }
        else {
            form.setFieldsValue({
                commitstatus: null
            })
        }
        if (option.key !== "Won" && option.key !== "Lost") {
            form.setFieldsValue({
                dealWonreasons: undefined,
                deallostReasons: undefined
            });
        }
        if (option.key === "on-Hold" || option.key === "On-Hold" || option.key === "Lost") {
            setOldPipeline(OldFixed)
        } else {
            setOldPipeline(null)
        }
        if (option.key === "Won" || option.key === "Lost") {
            form.setFieldsValue({
                winProbability: option.key === "Won" ? "100" : "0"
            })
            setWinProbability(option.key === "Won" ? "100" : "0")
        } else {
            // eslint-disable-next-line no-lonely-if
            if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
                form.setFieldsValue({
                    winProbability: winData
                })
                setWinProbability(winData)
            }
        }
    }
    const handleAccountChange = async (value) => {
        try {
            const response = await FetchContactByAccount(value)
            // const contactIds = (rId && rId !== "") ? rId?.split(',').map(id => id.trim()) : null
            // const updatedContactList = contactListData?.length ? contactListData.filter(contact =>
            //     response.some(apiContact => apiContact.contacts_id === contact.contacts_id)) : [];
            // if (contactIds?.length) {
            //     contactIds.forEach(contactId => {
            //         const contact = response.find(apiContact => apiContact.contacts_id === Number(contactId));
            //         const isAlreadyIncluded = updatedContactList.some(contact => contact.contacts_id === Number(contactId));
            //         if (contact && !isAlreadyIncluded) {
            //             updatedContactList.push(contact);
            //         }
            //     });
            // }
            setContacts(response)
        }
        catch (error) {
            message.error(error)
        }
        if (value) {
            try {
                const DealList = await FetchDealByAccount(value)
                // const updatedContactList = dealListData?.length
                //     ? dealListData.filter(deal =>
                //         DealList.some(apiDeal => apiDeal.deals_id === deal.deals_id))
                //     : [];

                // if (displayData?.parent_deal_id) {
                //     const parentDeal = DealList.find(
                //         deal => deal.deals_id === displayData.parent_deal_id
                //     );

                //     const isAlreadyIncluded = updatedContactList.some(
                //         deal => deal.deals_id === displayData.parent_deal_id
                //     );

                //     if (parentDeal && !isAlreadyIncluded) {
                //         updatedContactList.push(parentDeal);
                //     }
                // }
                setDealMapList(DealList)
            }
            catch (error) {
                message.error(error)
            }
        }
    }
    const onchangeDelete = (value) => {
        if (value) {
            form.setFieldsValue({
                contactPerson: [],
                parentDeal: null
            })
        }
    }
    const handleDealTypeChange = (value, option) => {
        setDealTypeData(value)
        setDealTypeField(option.key)
        if (option.key === "Empanelment") {
            form.setFieldsValue({
                typevalue: "Not Applicable",
                dealValue: 0,
                grossdealValue: 0,
                dealprofit: 0,
            });
            setTypeAction("Not Applicable")
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (typeAction === "Not Applicable") {
                form.setFieldsValue({
                    typevalue: null,
                })
                setTypeAction()
            }
        } if (option.key !== "Expansion") {
            form.setFieldsValue({
                parentDeal: null
            })
        }
    }
    function totalCalculation() {
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        let ChcekdealValueEdit;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    // sum = 1 * form.getFieldValue('grossdealValue');
                    sum = Number(dealValues) || 0;
                    setDealValueEdit()
                    ChcekdealValueEdit = undefined
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        // sum = 1 * form.getFieldValue('grossdealValue');
                        sum = Number(dealValues) || 0;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        // sum = 1 * form.getFieldValue('grossdealValue');
                        sum = Number(dealValues) || 0;
                    }
                    if ((formDatas.length > 0 && isFormDataValid) || (servicesData.length > 0 && isservicesDataValid)) {
                        setDealValueEdit("Disabled")
                        ChcekdealValueEdit = "Disabled"
                    }
                    else {
                        setDealValueEdit()
                        ChcekdealValueEdit = undefined
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                // sum = 1 * form.getFieldValue('grossdealValue');
                sum = Number(dealValues) || 0;
            }
        }
        if (typeAction === "Staff Augmentation") {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
        }
        if (!Number.isNaN(Number(dealDiscount)) && dealDiscount !== "" && dealDiscount !== 0) {
            totalsum = sum * (1 - Number(dealDiscount) / 100);
        } else {
            totalsum = sum;
        }
        if (!Number.isNaN(Number(winProbability)) && winProbability !== "" && totalDeal) {
            const dValue = 1 * totalDeal;
            Fvalue = dValue * (Number(winProbability) / 100);
        }
        if (pipeLineField !== "Won") {
            if (!Number.isNaN(Number(changeDealMargin)) && changeDealMargin !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin) / 100);
            }
        } else if (pipeLineField === "Won") {
            if (!Number.isNaN(Number(changeDealMargin2)) && changeDealMargin2 !== "" && totalDeal) {
                const dValue = 1 * totalDeal;
                profit = dValue * (Number(changeDealMargin2) / 100);
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            // grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        })
        if (((typeAction !== "Request for Proposal" && typeAction !== "Others") || ChcekdealValueEdit === "Disabled")) {
            form.setFieldsValue({
                grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            })
        }
        setTotalDeal(totalsum);
    }
    async function ProductApi() {
        try {
            const data = await getProjectList()
            const options = data.filter((item) => item.productActive === "Yes").map((option, i) => (
                <Option value={option.dealProductId} key={i} label={option.productName
                    // ( <div style={{ display: 'flex', alignItems: 'center' }}>
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={`${option.productName} (${option.prodcutCategory})`} style={{ cursor: "default" }}>
                    //             {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                    //                 < img src={option.productImg} alt="profile" />
                    //                 :
                    //                 <span className="image_icon">
                    //                     {option.productName?.slice(0, 1).toUpperCase()}
                    //                 </span>
                    //             }
                    //             <span className='div-ellipsis'>{option.productName}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={`${option.productName} (${option.prodcutCategory})`}>
                        <div>
                            {option.productImg !== null && option.productImg !== undefined && option.productImg !== "" ?
                                < img src={option.productImg} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.productName?.slice(0, 1).toUpperCase()}
                                </span>
                            }
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.productName}</p>
                            <p style={{ margin: 0 }}>({option.prodcutCategory})</p>
                        </div>
                    </div>
                </Option>));
            setProductdata(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function ServiceLineApi() {
        try {
            const data = await FetchAllServiceLines()
            const options = data.map((option, i) => (
                <Option value={option.service_line_id} key={i} label={option.service_line_name
                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                    //     <div className='Div_flex2'>
                    //         <div className='share_image' title={option.service_line_name} style={{ cursor: "default" }}>
                    //             <span className="image_icon">
                    //                 {option.service_line_name?.slice(0, 1).toUpperCase()}
                    //             </span>
                    //             <span className='div-ellipsis'>{option.service_line_name}</span>
                    //         </div>
                    //     </div>
                    // </div>)
                }>
                    <div className='UserList-dropdown' title={option.service_line_name}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.service_line_name?.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.service_line_name}</p>
                        </div>
                    </div>
                </Option>));
            setServiceLineData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function StaffRoleApi() {
        try {
            const data = await findAllStaffRoleByReportingUser()
            setStaffRoleData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getPipelineStage = async () => {
        try {
            const data = await FetchAllPipeline()
            setPipelineStage(data)
            if (FromPage === "AccountPage" || FromPage === "ContactPage") {
                handlePipeLineChange(data[0].pipelineStageId, { key: data[0].pipelineStageName })
                form.setFieldsValue({
                    pipelineStage: data[0].pipelineStageId
                })
            }
        }
        catch (error) {
            setPipelineStage([])
            message.error(error)
        }
    };
    async function getSelleingPrice(id) {
        try {
            const response = await getProductDetails(id)
            const price = response.sellingPricePerUnitPerMonth;
            const category = response.prodcutCategory;
            return { success: true, price, category };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    async function getStaffRolePrice(id) {
        try {
            const datas = await getByAddStaffRoleId(id);
            const price = datas.rolePerDayRate;
            return { success: true, price };
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    const getWorkingDays = async (id, startDate, endDate) => {
        try {
            const response = await getBussinesDaysForStaffRole(id, startDate, endDate)
            return { success: true, data: response }
        } catch (error) {
            return {
                success: false,
                message: error
            };
        }
    }
    // add Product
    const handleFieldChange = async (index, fieldName, value) => {
        const updatedFormData = [...formDatas];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };

        const productId = updatedFormData[index].dealProductId;
        if (productId) {
            const response = await getSelleingPrice(productId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].productLicenseSellingPriceUnitMonth = 0;
                updatedFormData[index].productCategory = null;
                updatedFormData[index].licenseDuration = 1;
            }
            else {
                const Value = response.price
                    ? await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].productLicenseSellingPriceUnitMonth = Number(Value?.toFixed(CurencyDecimalPlace));
                updatedFormData[index].productCategory = response.category;
                if (response.category !== "Software") {
                    updatedFormData[index].licenseDuration = 1;
                } else {
                    updatedFormData[index].licenseDuration = updatedFormData[index].licenseDuration && updatedFormData[index].licenseDuration !== "" ?
                        updatedFormData[index].licenseDuration : 1
                }
            }
        }

        const productLicenseSellingPriceUnitMonth = parseFloat(updatedFormData[index].productLicenseSellingPriceUnitMonth || 0);
        const numberOfUnits = parseFloat(updatedFormData[index].numberOfUnits || 0);
        const licenseDuration = parseFloat(updatedFormData[index].licenseDuration || 0);
        // const subtotal = parseFloat(updatedFormData[index].subtotal || 0);
        // const adjType = updatedFormData[index].adjustmentType;
        // const adjustments = parseFloat(updatedFormData[index].adjustments || 0);

        if (productLicenseSellingPriceUnitMonth > 0 && numberOfUnits > 0 && licenseDuration > 0) {
            // updatedFormData[index].subtotal = (productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration)?.toFixed(2);
            // if (adjustments === 0) {
            updatedFormData[index].total = (productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration)?.toFixed(CurencyDecimalPlace);
            // }
            // else if (adjustments > 0 && adjType === "%") {
            // updatedFormData[index].total = ((productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration) * (1 - adjustments / 100))?.toFixed(2);
            // }
            // else if (adjustments > 0 && adjType === "-") {
            // updatedFormData[index].total = ((productLicenseSellingPriceUnitMonth * numberOfUnits * licenseDuration) - adjustments)?.toFixed(2);
            // }
        } else {
            // updatedFormData[index].subtotal = '';
            updatedFormData[index].total = "";

        }
        setFormDatas(updatedFormData)
    };
    const addNewRow = () => {
        setFormDatas([...formDatas,
        {
            dealProductId: null,
            productCategory: null,
            productLicenseSellingPriceUnitMonth: null,
            numberOfUnits: null,
            licenseDuration: null,
            // subtotal: '',
            // adjustmentType: '%',
            // adjustments: '',
            total: null,
        }]);
    };
    const removeRow = async (index) => { // value
        const updatedFormData = [...formDatas];
        updatedFormData.splice(index, 1);
        setFormDatas(updatedFormData);
    }
    // add services
    const addNewSerivce = () => {
        // setServiceData([...servicesData, {}]);
        setServiceData([...servicesData,
        {
            serviceName: null,
            serviceLineId: null,
            serviceLineCost: null,
        },
        ]);
    };
    const removeservice = async (index) => { // value
        const updatedFormData = [...servicesData];
        updatedFormData.splice(index, 1);
        setServiceData(updatedFormData);
    };
    const handleServicesChange = async (index, fieldName, value) => {
        const updatedFormData = [...servicesData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [fieldName]: value,
        };
        setServiceData(updatedFormData);
    };
    // add roles
    const addNewRoles = () => {
        setRoleData([...roleData, {
            addStaffRoleId: null,
            country: null,
            rolePerDayRate: null,
            startDate: null,
            endDate: null,
            totalValue: null,
        }]);
    };
    const removeRoles = async (index) => { // value
        const updatedFormData = [...roleData];
        updatedFormData.splice(index, 1);
        setRoleData(updatedFormData);
    };
    const handleRolesChange = async (index, fieldName, value, countrys) => {
        const updatedFormData = [...roleData];
        if ((fieldName === "startDate" || fieldName === "endDate") && value) {
            const date = RequiredDateFormating(value)
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: date,
                country: countrys,
            };
        }
        else {
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                country: countrys,
            };
        }
        const staffRoleId = updatedFormData[index].addStaffRoleId;
        if (staffRoleId) {
            const response = await getStaffRolePrice(staffRoleId)
            if (!response.success) {
                message.error(response.message);
                updatedFormData[index].rolePerDayRate = 0;
            }
            else {
                const Value = response.price ?
                    await ExchangeCurrency(Number(response.price), ConvertRate)
                    : response.price;
                updatedFormData[index].rolePerDayRate = Number(Value?.toFixed(CurencyDecimalPlace));
            }
        }
        const rolePerDayRate = parseFloat(updatedFormData[index].rolePerDayRate || 0);
        let totalBusinessDays = 0;

        if (staffRoleId && updatedFormData[index].startDate && updatedFormData[index].endDate) {
            const responseData = await getWorkingDays(staffRoleId, updatedFormData[index].startDate, updatedFormData[index].endDate);
            if (!responseData.success) {
                message.error(responseData.message);
                totalBusinessDays = 0;
            }
            else {
                totalBusinessDays = responseData.data
            }
        } if (rolePerDayRate > 0 && totalBusinessDays > 0) {
            const total = rolePerDayRate * totalBusinessDays
            updatedFormData[index].totalValue = total?.toFixed(CurencyDecimalPlace)
        }
        else {
            updatedFormData[index].totalValue = ""
        }
        setRoleData(updatedFormData);
    };
    const handleTypeAction = (value) => {
        setTypeAction(value)
        setRoleData([])
        setServiceData([])
        setFormDatas([])
        if (value === "Staff Augmentation" && roleData.length === 0) {
            addNewRoles()
            form.setFieldsValue({
                revenueStartDate: null,
                revenueEndDate: null,
            })
            setRevenueStartDate(null)
            setRevenueEndDate(null)
        }
        if (value === "Request for Proposal" || value === "Product and Services") {
            if (formDatas.length === 0) {
                addNewRow()
            }
            if (servicesData.length === 0) {
                addNewSerivce()
            }
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        form.setFieldsValue({ expectedClosureDate: date });
        form.validateFields(['revenueStartDate', 'revenueEndDate']);
    };
    const revenueStartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueStartDate(formattedDate);
        form.setFieldsValue({ revenueStartDate: date });
        form.validateFields(['expectedClosureDate', 'revenueEndDate']);
    };
    const revenueEndDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueEndDate(formattedDate);
        form.setFieldsValue({ revenueEndDate: date });
        form.validateFields(['revenueStartDate']);
    };
    const actualclosuredateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setActualclosureDate(formattedDate);
    };
    const dealLostDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealLostDate(formattedDate);
    };
    const dealonholdDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealonholdDate(formattedDate);
    };
    const dealrestartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDealrestartDate(formattedDate);
    };
    // const customDisabledDate = (currentDate) => {
    //     if (expectedClosureDate) {
    //         const formate = formatDateString(expectedClosureDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
    //         return moment(currentDate).isBefore(moment(formate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), 'day');
    //     }
    //     return moment(currentDate).isBefore(moment(), 'day');
    // };
    const ProductColumns = [
        {
            title: 'Product Name',
            dataIndex: 'PrdutName',
            key: 'PrdutName',
            width: '18%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Product"
                        // dropdownRender={(menu) => (
                        //     <>
                        //         {menu}
                        //         <Divider style={{ margin: '10px 0' }} />
                        //         <Space style={{ padding: '0 8px 4px' }}>
                        //             <Button size="small" className="button_colors" onClick={() => handleProduct(true, index, "Product")}>
                        //                 <FeatherIcon icon="plus-circle" /> Add Product
                        //             </Button>
                        //         </Space>
                        //     </>
                        // )}
                        name="dealProductId"
                        value={record.dealProductId}
                        onChange={(value) =>
                            handleFieldChange(index, 'dealProductId', value)
                        }
                    >
                        {productdata}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Unit Price (${defaultCurrency?.currency})`,
            dataIndex: 'PriceperU/M$',
            key: 'PriceperU/M$',
            width: '13%',
            render: (text, record, index) => (
                <Form.Item>
                    <Input pattern="^\d+(\.\d+)?$" disabled prefix={defaultCurrency?.symbol}
                        name="productLicenseSellingPriceUnitMonth"
                        value={record.productLicenseSellingPriceUnitMonth}
                        onChange={(e) =>
                            handleFieldChange(index, 'productLicenseSellingPriceUnitMonth', e.target.value)
                        }
                        placeholder="Unit Price" />
                </Form.Item>
            ),
        },
        {
            title: 'No. of Units',
            dataIndex: 'Numofunits',
            key: 'Numofunits',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}><Input min={0}
                    name="numberOfUnits"
                    value={record.numberOfUnits}
                    onChange={(e) => {
                        const { value } = e.target;
                        const isValid = /^\d+(\.\d+)?$/.test(value);
                        if (value === "" || isValid) {
                            handleFieldChange(index, "numberOfUnits", value);
                        }
                    }}
                    placeholder="Number of Units" />
                </Form.Item>
            ),
        },
        {
            title: (
                <div>
                    Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="License Duration in months" />
                </div>
            ),
            dataIndex: 'LicenseDutn',
            key: 'LicenseDutn',
            width: '5%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input min={0}
                        disabled={record.productCategory !== "Software"}
                        name="licenseDuration"
                        value={record.productCategory && record.productCategory !== "Software" ? "One off" : record.licenseDuration}
                        onChange={(e) => {
                            const { value } = e.target;
                            const isValid = /^\d+(\.\d+)?$/.test(value);
                            if (value === "" || isValid) {
                                handleFieldChange(index, "licenseDuration", value);
                            }
                        }}
                        placeholder="License Duration" />
                </Form.Item>
            ),
        },
        // {
        //     title: `Subtotal (${defaultCurrency?.currency})`,
        //     dataIndex: 'Subtotal',
        //     key: 'Subtotal',
        //     width: '20%',
        //     render: (text, record, index) => (
        //         <Form.Item>
        //             {edit ? <Input prefix={defaultCurrency?.symbol}
        //                 // type="number"
        //                 disabled min={0}
        //                 name="subtotal"
        //                 value={record.subtotal}
        //                 onChange={(e) =>
        //                     handleFieldChange(index, 'subtotal', e.target.value)
        //                 }
        //                 placeholder="Subtotal" />
        //                 : <>{defaultCurrency?.symbol} <span >
        //                     {displayData?.products[index]?.subtotal?.toLocaleString()}
        //                 </span></>}
        //         </Form.Item>
        //     ),
        // },
        // {
        //     title: 'Discount',
        //     dataIndex: 'Adjustments',
        //     key: 'Adjustments',
        //     width: '15%',
        //     render: (text, record, index) => (
        //         <Form.Item>
        //             {edit ?
        //                 <Input type="number" min={0}
        //                     addonAfter={(
        //                         <Select value={record.adjustmentType} onChange={(value) => handleFieldChange(index, 'adjustmentType', value)} style={{ width: "50px" }}>
        //                             <Option value="%">%</Option>
        //                             <Option value="-">{defaultCurrency?.symbol}</Option>
        //                         </Select>)}
        //                     name="adjustments"
        //                     value={record.adjustments}
        //                     onChange={(e) =>
        //                         handleFieldChange(index, 'adjustments', e.target.value)
        //                     }
        //                     placeholder="Discount" />
        //                 : <>{record.adjustments !== undefined &&
        //                     record.adjustments !== '' &&
        //                     record.adjustments !== null &&
        //                     (record.adjustmentType === "%" ? "%" :
        //                         defaultCurrency?.symbol)} <span >
        //                         {record.adjustments !== undefined &&
        //                             record.adjustments !== '' &&
        //                             record.adjustments !== null &&
        //                             (record.adjustmentType === "%" ?
        //                                 displayData?.products[index]?.adjustments
        //                                 : displayData?.products[index]?.adjustments?.toLocaleString()
        //                             )}
        //                     </span></>}
        //         </Form.Item>
        //     ),
        // },
        {
            title: `Total (${defaultCurrency?.currency})`,
            dataIndex: 'Total',
            key: 'Total',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input type="text" disabled prefix={defaultCurrency?.symbol}
                        name="total"
                        value={record.total}
                        onChange={(e) =>
                            handleFieldChange(index, 'total', e.target.value)
                        }
                        placeholder="Total" />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && formDatas.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px", }} className="fetcherDelete-Icon"
                            // onClick={() => removeRow(index, record.addProductId)}
                            onClick={() => removeRow(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === formDatas.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Product"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRow}
                        />
                    );
                }
            },
        }
    ];
    const ServicesColumns = [
        {
            title: 'Service Name',
            dataIndex: 'ServiceName',
            key: 'ServiceName',
            width: '30%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Input placeholder='Enter Service Name'
                        name="serviceName"
                        value={record.serviceName}
                        onChange={(e) =>
                            handleServicesChange(index, 'serviceName', e.target.value)
                        } />
                </Form.Item>
            ),
        },
        {
            title: 'Service Line Name',
            dataIndex: 'ServiceLineName',
            key: 'ServiceLineName',
            width: '35%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Enter Service Line Name"
                        // dropdownRender={(menu) => (
                        //     <>
                        //         {menu}
                        //         <Divider style={{ margin: '10px 0' }} />
                        //         <Space style={{ padding: '0 8px 4px' }}>
                        //             <Button size="small" className="button_colors" onClick={() => handleService(true, index, "DealPageService")}>
                        //                 <FeatherIcon icon="plus-circle" /> Add Service Line
                        //             </Button>
                        //         </Space>
                        //     </>
                        // )}
                        name="serviceLineId"
                        value={record.serviceLineId}
                        onChange={(value) =>
                            handleServicesChange(index, 'serviceLineId', value)
                        }
                    >
                        {serviceLineData}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Service Line Cost (${defaultCurrency?.currency})`,
            dataIndex: 'ServiceLineCost',
            key: 'ServiceLineCost',
            width: '31%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}> <Input placeholder='Enter Service Line Cost' min={0} prefix={defaultCurrency?.symbol}
                    name="serviceLineCost"
                    value={record.serviceLineCost}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (value === "") {
                            handleServicesChange(index, "serviceLineCost", value);
                            return;
                        }

                        // Allow only numeric input with optional decimal
                        const basicNumberCheck = /^\d+(\.\d*)?$/;
                        if (!basicNumberCheck.test(value)) return;

                        // Allow only up to CurencyDecimalPlace decimal places
                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                        if (!decimalRegex.test(value)) return;

                        // All checks passed
                        handleServicesChange(index, "serviceLineCost", value);
                    }} />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: '2%',
            render: (text, record, index) => {
                if (edit && servicesData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            // onClick={() => removeservice(index, record.serviceId)}
                            onClick={() => removeservice(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            width: '2%',
            render: (text, record, index) => {
                if (edit && index === servicesData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Services"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewSerivce}
                        />
                    );
                }
            },
        }
    ];
    const StaffColumns = [
        {
            title: 'Role Name',
            dataIndex: 'RoleName',
            key: 'RoleName',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <Select style={{ width: "100%" }}
                        showSearch
                        optionFilterProp="children" optionLabelProp="label"
                        filterOption={(input, option) => {
                            const usernameElement = option.children.props.children[1].props.children[0];
                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                const username = String(usernameElement.props.children);
                                return username.toLowerCase().includes(input.toLowerCase());
                            }
                            return false;
                        }
                        }
                        placeholder="Select Staff Role"
                        name="addStaffRoleId"
                        value={record.addStaffRoleId}
                        onChange={(value, option) => {
                            handleRolesChange(index, 'addStaffRoleId', value, option.name);
                        }}
                    >
                        {staffRoleData.map((option, i) => (
                            <Option value={option.addStaffRoleId} key={i} name={option.country}
                                label={option.roleName
                                    // (<div style={{ display: 'flex', alignItems: 'center' }} >
                                    //     <div className='Div_flex2'>
                                    //         <div className='share_image' title={`${option.roleName} (${option.country})`} style={{ cursor: "default" }}>
                                    //             <span className="image_icon">
                                    //                 {option.roleName?.slice(0, 1).toUpperCase()}
                                    //             </span>
                                    //             <span className='div-ellipsis'>{option.roleName}</span>
                                    //         </div>
                                    //     </div>
                                    // </div>)
                                }>
                                <div className='UserList-dropdown' title={`${option.roleName} (${option.country})`}>
                                    <div>
                                        <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.roleName?.slice(0, 1).toUpperCase()}
                                        </span>
                                    </div>
                                    <div>
                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.roleName}</p>
                                        <p style={{ margin: 0 }}>({option.country})</p>
                                    </div>
                                </div>
                            </Option>))}
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: `Per Day Rate (${defaultCurrency?.currency})`,
            dataIndex: 'RolePerDayRate',
            key: 'RolePerDayRate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item> <Input placeholder='Role Per Day Rate' pattern="^\d+(\.\d+)?$" min={0}
                    name="rolePerDayRate" prefix={defaultCurrency?.symbol}
                    disabled
                    value={record.rolePerDayRate}
                    onChange={(e) =>
                        handleRolesChange(index, 'rolePerDayRate', e.target.value, record.country)
                    } />
                </Form.Item>
            ),
        },
        {
            title: 'Start Date',
            dataIndex: 'StartDate',
            key: 'StartDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <DatePicker
                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                        name="startDate"
                        disabledDate={(current) => {
                            const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;
                            const end = record.endDate ? moment(record.endDate, "YYYY-MM-DD").startOf("day") : null;

                            return current && (
                                current < moment().startOf("day") || // disallow past
                                (closure && current.isBefore(closure, 'day')) || // ✅ allow same as closure
                                (end && current.isAfter(end, 'day'))             // ✅ allow same as end
                            );
                        }}
                        placeholder="Select Start Date"
                        onChange={(date, dateString) =>
                            handleRolesChange(index, 'startDate', dateString, record.country)
                        }
                    />
                </Form.Item>
            ),
        },
        {
            title: 'End Date',
            dataIndex: 'EndDate',
            key: 'EndDate',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item style={{ margin: "0px 5px" }}>
                    <DatePicker
                        name="endDate"
                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                        disabledDate={(current) => {
                            const start = record.startDate ? moment(record.startDate, "YYYY-MM-DD").startOf("day") : null;
                            const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;

                            return current && (
                                current < moment().startOf("day") || // ❌ disallow past
                                (start && current.isBefore(start, 'day')) || // ❌ disallow before start
                                (closure && current.isBefore(closure, 'day')) // ❌ disallow before closure
                            );
                        }}
                        placeholder="Select End Date"
                        onChange={(date, dateString) =>
                            handleRolesChange(index, 'endDate', dateString, record.country)
                        }
                    />
                </Form.Item>
            ),
        },
        {
            title: `Total Value (${defaultCurrency?.currency})`,
            dataIndex: 'TotalValue',
            key: 'TotalValue',
            width: '20%',
            render: (text, record, index) => (
                <Form.Item> <Input placeholder='Enter Total Value' disabled prefix={defaultCurrency?.symbol}
                    name="totalValue"
                    value={record.totalValue}
                    onChange={(e) =>
                        handleRolesChange(index, 'totalValue', e.target.value, record.country)
                    } />
                </Form.Item>
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && roleData.length > 0) {
                    return (
                        <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px" }} className="fetcherDelete-Icon"
                            // onClick={() => removeRoles(index, record.staffRoleId)}
                            onClick={() => removeRoles(index)}
                        />
                    );
                }
            },
        },
        {
            title: '',
            dataIndex: 'addAction',
            key: 'addAction',
            // width: '5%',
            render: (text, record, index) => {
                if (edit && index === roleData.length - 1) {
                    return (
                        <PlusCircleOutlined
                            title="Add New Staff Augmentation"
                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
                            onClick={addNewRoles}
                        />
                    );
                }
            },
        }
    ];
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: '.png,.jpg,.jpeg',
        beforeUpload: (file) => {
            const allowedTypes = ['image/png', 'image/jpeg'];
            if (!allowedTypes.includes(file.type)) {
                message.error('Only PNG, JPG and JPEG images are allowed');
                return false;
            }
            const maxSize = 100 * 1024;
            if (file.size > maxSize) {
                message.error('Image size must be 100 KB or less');
                return false;
            }
            return true;
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            const hideUploadMessage = message.loading("Uploading profile picture...", 0);
            setImageUploading(true);
            try {
                const formData = new FormData();
                formData.append("file", file);
                const response = await getAxiosInstance().post(
                    "/usermgmt/uploadFile",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                onSuccess(response.data);
            } catch (error) {
                onError(error);
            } finally {
                hideUploadMessage();
                setImageUploading(false);
            }
        },
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const OndealvalueChange = (value) => {
        setDealValue(value)
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    dealOwner: profile.userId,
                    priority: 2,
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            AccountApi(),
            getPipelineStage(),
            UserDetailsApi(),
            getAllAccoutbyType(),
            PriorityApi(),
            DealTypeApi(),
            DealLoseApi(),
            DealOnHoldApi(),
            DealWonApi(),
            ProductApi(),
            ServiceLineApi(),
            StaffRoleApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage) {
            form.setFieldsValue({
                dealOwner: undefined,
                parentDeal: undefined,
                dealprofit: undefined,
                dealname: undefined,
                // dealDescription: undefined,
                priority: undefined,
                dealmargin: 0,
                expectedClosureDate: null,
                winProbability: 0,
                forecastedValue: undefined,
                revenueStartDate: undefined,
                revenueEndDate: undefined,
                commitstatus: undefined,
                pipelineStage: 1,
                deallostReasons: undefined,
                dealWonreasons: undefined,
                dealValue: undefined,
                grossdealValue: undefined,
                dealType: undefined,
                typevalue: undefined,
                dealonHoldReason: undefined,
                actualdealmargin: undefined,
                competition: [],
                discountvalue: 0,
                tags: undefined
            })
            setContent1()
            setDisplayData("Create")
            setDealInitial(InitialData.DealData)
            setDataPermissions("Read,Update,Delete,Sharing")
            getUserDetail()
            setEdit(true)
            setEditableType(true)
            form.setFieldsValue({
                actualclosureDate: moment(formattedCurrentDate),
                dealLostDate: moment(formattedCurrentDate),
                dealonholdDate: moment(formattedCurrentDate),
                dealrestartDate: moment(formattedCurrentDate),
            })
            setActualclosureDate(formattedCurrentDate)
            setDealLostDate(formattedCurrentDate)
            setDealonholdDate(formattedCurrentDate)
            setDealrestartDate(formattedCurrentDate)
            setEditField(true)
        }
    }, [UrlId, defaultCurrency, FromPage, drawerPage]);
    useEffect(() => {
        if (typeAction === "Staff Augmentation" && FromPage) {
            let minStart = null;
            let maxEnd = null;
            roleData.forEach(role => {
                const { startDate, endDate } = role;
                const parsedStartDate = startDate !== null && startDate !== undefined && startDate !== "" ? startDate : null
                const parsedEndDate = endDate !== null && endDate !== undefined && endDate !== "" ? endDate : null
                if (!minStart || (parsedStartDate && parsedStartDate < minStart)) {
                    minStart = parsedStartDate;
                }
                if (!maxEnd || (parsedEndDate && parsedEndDate > maxEnd)) {
                    maxEnd = parsedEndDate;
                }
            });
            const StartDateFormate = formatDateString(minStart, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const EndDateFormate = formatDateString(maxEnd, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            form.setFieldsValue({
                revenueStartDate: minStart !== null && minStart !== undefined && minStart !== "" ? moment(StartDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
                revenueEndDate: maxEnd !== null && maxEnd !== undefined && maxEnd !== "" ? moment(EndDateFormate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD") : null,
            })
            setRevenueStartDate(minStart);
            setRevenueEndDate(maxEnd);
        }
    }, [roleData, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, totalDeal, FromPage, changeDealMargin, changeDealMargin2, pipeLineField])
    useEffect(() => {
        if (FromPage) {
            if (FromPage === "AccountPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId
                })
                handleAccountChange(dataForDeal?.AccountId)
            }
            if (FromPage === "ContactPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId,
                    // check the contact person 
                    contactPerson: dataForDeal?.contactId
                })
                handleAccountChange(dataForDeal?.AccountId)
            }
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage && editField && displayData && defaultCurrency) {
            fetchAll()
        }
    }, [displayData, FromPage, defaultCurrency, editField])
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            dealOwner: null,
            dealname: null,
            parentDeal: null,
            dealprofit: null,
            accountName: null,
            contactPerson: [],
            priority: null,
            dealmargin: null,
            expectedClosureDate: null,
            winProbability: null,
            forecastedValue: null,
            revenueStartDate: null,
            revenueEndDate: null,
            commitstatus: null,
            pipelineStage: 1,
            deallostReasons: null,
            dealWonreasons: null,
            dealValue: null,
            grossdealValue: null,
            dealType: null,
            typevalue: null,
            dealonHoldReason: null,
            actualdealmargin: null,
            actualclosureDate: null,
            dealLostDate: null,
            dealonholdDate: null,
            dealrestartDate: null,
            competition: [],
            discountvalue: null,
            // dealDescription: null,
            tags: null
        })
        setContent1()
        setTempWinProp()
        setFileList([])
        setDealValue(0)
        setTotalDeal(0)
        setExpectedClosureDate()
        setRevenueStartDate()
        setRevenueEndDate()
        setActualclosureDate()
        setDealLostDate()
        setDealonholdDate()
        setDealrestartDate()
        setWinProbability()
        setDealDiscount()
        setRoleData([])
        setServiceData([])
        setFormDatas([])
        handleDealTypeChange(undefined, { key: undefined })
        setTypeAction()
        setImage()
        setDeleteOpen(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setOldPipeline()
        setOldFixed()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage" && FromPage !== "ContactPage") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditWon(false);
        setEditableType(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const validateRows = (rows, requiredFields, entityName = 'Row') => {
        const rowIndex = rows.findIndex(row =>
            requiredFields.some(
                field => row[field] === null || row[field] === undefined || row[field] === ''
            )
        );
        if (rowIndex !== -1) {
            message.error(<span>
                Please complete the missing fields in Row <strong>{rowIndex + 1}</strong> under <strong>{entityName}</strong>
            </span>);
            return false; // stop execution
        }
        return true; // all rows valid
    };
    const hasAnyValue = (item) => {
        return Object.values(item).some(val => val !== null && val !== undefined && val !== '');
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        if (typeAction === "Request for Proposal") {
            if (formDatas.length > 0) {
                const anyValue = formDatas.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
                }
            }
            if (servicesData.length > 0) {
                const anyValue = servicesData.some(row => hasAnyValue(row));
                if (anyValue) {
                    if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
                }
            }
        }
        if (typeAction === "Product and Services") {
            const productsHaveData = formDatas.some(hasAnyValue);
            const servicesHaveData = servicesData.some(hasAnyValue);
            if (!productsHaveData && !servicesHaveData) {
                message.error("Please add at least one Product or Service");
                return;
            }
            if (productsHaveData) {
                if (!validateRows(formDatas, ['dealProductId', 'numberOfUnits', 'licenseDuration'], 'Add Products')) return;
            }
            if (servicesHaveData) {
                if (!validateRows(servicesData, ['serviceName', 'serviceLineId', 'serviceLineCost'], 'Add Services')) return;
            }
        }
        if (typeAction === "Staff Augmentation") {
            if (roleData.length > 0) { if (!validateRows(roleData, ['addStaffRoleId', 'country', 'rolePerDayRate', 'startDate', 'endDate', 'totalValue'], 'Add Roles')) return; }
        }
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { accountName, contactPerson, competition, dealprofit, parentDeal, deallostReasons, dealOwner, dealType, grossdealValue, dealValue, dealWonreasons, commitstatus, dealmargin, dealname, forecastedValue, pipelineStage, priority, winProbability, typevalue, dealonHoldReason, actualdealmargin,
            tags
        } = values;
        const allTags = tags?.join(",") || ""
        const DealValue = dealValue
            ? await convertCurrency(ConvertRate, Number(dealValue))
            : dealValue;
        const ProfitValue = dealprofit
            ? await convertCurrency(ConvertRate, Number(dealprofit))
            : dealprofit;
        const GrossDealValue = grossdealValue
            ? await convertCurrency(ConvertRate, Number(grossdealValue))
            : grossdealValue;
        const ForecastedValue = forecastedValue
            ? await convertCurrency(ConvertRate, Number(forecastedValue))
            : forecastedValue;
        const convertedServicesData = await Promise.all(
            servicesData.map(async (service) => {
                const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                    convertCurrency(ConvertRate, Number(service.serviceLineCost))
                    : service.serviceLineCost
                );
                return {
                    ...service,
                    serviceName: normalizeValue(service.serviceName),
                    serviceLineId: normalizeValue(service.serviceLineId),
                    serviceLineCost: convertedCost?.toString(),
                };
            })
        );
        const convertedRoleData = await Promise.all(
            roleData.map(async (role) => {
                const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                    ? convertCurrency(ConvertRate, Number(role.rolePerDayRate))
                    : role.rolePerDayRate);
                const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                    convertCurrency(ConvertRate, Number(role.totalValue))
                    : role.totalValue);
                return {
                    ...role,
                    addStaffRoleId: normalizeValue(role.addStaffRoleId),
                    country: normalizeValue(role.country),
                    startDate: normalizeValue(role.startDate),
                    endDate: normalizeValue(role.endDate),
                    rolePerDayRate: convertedRate?.toString(),
                    totalValue: convertedTotalValue?.toString(),
                };
            })
        );
        const convertedFormDatas = await Promise.all(
            formDatas.map(async (product) => {
                const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                    ? convertCurrency(ConvertRate, Number(product.productLicenseSellingPriceUnitMonth))
                    : product.productLicenseSellingPriceUnitMonth);
                // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
                //     ? convertCurrency(ConvertRate, Number(product.subtotal))
                //     : product.subtotal);
                const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                    ? convertCurrency(ConvertRate, Number(product.total))
                    : 0);
                // let convertedAdjustments = product.adjustments;
                // if (product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%") {
                //     convertedAdjustments = await convertCurrency(ConvertRate, Number(product.adjustments))
                // }
                return {
                    ...product,
                    dealProductId: normalizeValue(product.dealProductId),
                    productCategory: normalizeValue(product.productCategory),
                    numberOfUnits: normalizeValue(product.numberOfUnits),
                    licenseDuration: normalizeValue(product.licenseDuration),
                    productLicenseSellingPriceUnitMonth: convertedPrice?.toString(),
                    total: convertedTotal?.toString(),
                };
            })
        );
        const formData =
        {
            dealOwner: normalizeValue(dealOwner),
            parentDealId: normalizeValue(parentDeal),
            dealProfit: normalizeValue(ProfitValue?.toString()),
            dealName: normalizeValue(dealname),
            dealType: normalizeValue(dealType),
            dealProfile: normalizeValue(image),
            subtype: normalizeValue(typevalue),
            accountName: normalizeValue(accountName),
            pipelineStage: normalizeValue(pipelineStage),
            oldPipelineStage: normalizeValue((pipeLineField === "on-Hold" || pipeLineField === "On-Hold" || pipeLineField === "Lost") ? oldPipeline : null),
            contactPerson: (contactPerson && contactPerson.length > 0) ? contactPerson.join(',') : null,
            dealValue: normalizeValue(DealValue?.toString()),
            priority: normalizeValue(priority),
            dealFiles: FILEList,
            expectedDealLength: normalizeValue(pipeLineField === "Won" ? actualdealmargin : dealmargin),
            expectedClosureDate: normalizeValue(expectedClosureDate),
            winProbability: normalizeValue(winProbability),
            competition: (competition && competition.length > 0) ? competition.join(',') : null,
            forecastedValue: normalizeValue(ForecastedValue?.toString()),
            revenueStartDate: normalizeValue(revenueStartDate),
            revenueEndDate: normalizeValue(revenueEndDate),
            grossDealValue: normalizeValue(GrossDealValue?.toString()),
            discountPercentage: normalizeValue(dealDiscount),
            dealDescription: normalizeValue(content1),
            tags: normalizeValue(allTags)
        }
        formData.commitStatus =
            (pipeLineField !== "Prospecting" && pipeLineField !== "Qualification" && pipeLineField !== "Discovery")
                ? normalizeValue(commitstatus) : null;
        if (pipeLineField === "Won") {
            formData.dealWonReason = normalizeValue(dealWonreasons);
            formData.actualCloserDate = normalizeValue(actualclosureDate);
            formData.actualDealMargin = normalizeValue((actualdealmargin && actualdealmargin !== "") ? Number(actualdealmargin) : undefined)
        } else { formData.dealWonReason = null; formData.actualCloserDate = null; formData.actualDealMargin = null; }
        if (pipeLineField === "Lost") {
            formData.dealLostReason = normalizeValue(deallostReasons);
            formData.dealLostDate = normalizeValue(dealLostDate);
        }
        else { formData.dealLostReason = null; formData.dealLostDate = null; }
        if (pipeLineField === "on-Hold" || pipeLineField === "On-Hold") {
            formData.dealHoldReason = normalizeValue(dealonHoldReason);
            formData.dealHoldDate = normalizeValue(dealonholdDate);
            formData.dealRestartDate = normalizeValue(dealrestartDate);
        }
        else { formData.dealHoldReason = null; formData.dealHoldDate = null; formData.dealRestartDate = null; }
        const hasValidData = (obj) =>
            Object.values(obj).some(val => val !== null && val !== undefined && val !== "");
        if (typeAction === "Staff Augmentation") {
            formData.staffRole = convertedRoleData;
            formData.products = [];
            formData.services = [];
        } else if (typeAction === "Product and Services" || typeAction === "Request for Proposal") {
            formData.products = convertedFormDatas.filter(hasValidData);
            formData.services = convertedServicesData.filter(hasValidData);
            formData.staffRole = [];
        } else {
            formData.staffRole = [];
            formData.products = [];
            formData.services = [];
        }
        const updatedFields = getChangedFields(formData, dealInitial);
        if (Object.keys(updatedFields).length === 0) {
            message.success("Deal updated")
            setEdit(false)
            setEditWon(false)
            dispatch(setEditCall(false));
            setEditField(false)
            CloseDrawer()
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await createDeals(updatedFields)
            if (response.status === 201) {
                dispatch(setEditCall(false))
                setEditField(false)
                setEdit(false)
                setEditWon(false)
                loadingRef.current = false;
                setDoubleClick(false)
                hideMessage();
                if (response?.data === AutomationMessage) {
                    if (FromPage === "ContactPage") {
                        dispatch(setExPoCall(true));
                        successMessage("Automation rule triggered", response?.data)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else if (FromPage === "AccountPage" && pipeLineField === "Won") {
                        dispatch(setExPoCall(true));
                        successMessage("Automation rule triggered", response?.data)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else {
                        setTimeout(() => {
                            CloseDrawer()
                        }, 2000);
                        successMessage("Automation rule triggered", response?.data)
                    }
                }
                else if (response?.data === ApprovalMessage) {
                    setTimeout(() => {
                        CloseDrawer()
                    }, 2000);
                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                }
                else if (response?.data !== ApprovalMessage && response?.data !== AutomationMessage) {
                    if (FromPage === "ContactPage") {
                        dispatch(setExPoCall(true));
                        if (pipeLineField === "Won") {
                            successMessage("Deal Won",
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Won.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                                </>)
                        } else {
                            successMessage("Deal created", <>
                                <img
                                    src={require('../../../static/img/defaultImages/Deal.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                            </>)
                        }
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else if (FromPage === "AccountPage" && pipeLineField === "Won") {
                        dispatch(setExPoCall(true));
                        successMessage("Deal Won",
                            <>
                                <img
                                    src={require('../../../static/img/defaultImages/Won.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span>Deal Closed! Congratulations on winning the deal! Time to celebrate your success!</span>
                            </>)
                        setTimeout(() => {
                            dispatch(setExPoCall(false));
                            CloseDrawer()
                        }, 3000);
                    }
                    else {
                        setTimeout(() => {
                            CloseDrawer()
                        }, 2000);
                        successMessage("Deal created", <>
                            <img
                                src={require('../../../static/img/defaultImages/Deal.gif')}
                                alt="celebration"
                                style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                            />
                            <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                        </>)
                    }
                }
                else {
                    setTimeout(() => {
                        CloseDrawer()
                    }, 2000);
                    successMessage("Deal created", <>
                        <img
                            src={require('../../../static/img/defaultImages/Deal.gif')}
                            alt="celebration"
                            style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                        />
                        <span>New Deal Created! You&apos;ve just kicked off a new opportunity. Let&apos;s make it happen!</span>
                    </>)
                }
                if (FromPage === "AccountPage" || FromPage === "ContactPage") {
                    CallBackTrigger("Callback")
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(error)
        }
    }
    const PageCancel1 = () => {
        setCancelConfirmOpen(true)
    }

    const handleChange1 = (val) => {
        setContent1(val);
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={FromPage === "EntityUpdate" ? "Update Deal" : "Create Deal"}
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={uiReady ? [
                    <div className="form_action_button">
                        <Button
                            className="gray-button" size="small"
                            onClick={() => PageCancel1()}
                        >
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={doubleClick} loading={doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                        </Button>
                    </div>] : false
                }
            >
                {uiReady ? <Scrollbars ref={scrollRef} autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false} >
                                <BasicFormWrapper>
                                    <VerticalFormStyleWrap>
                                        <div className="add-product-block">
                                            <div style={{ margin: 40 }}>
                                                <Row gutter={15}>
                                                    <Col xs={24}>
                                                        <div className="add-product-content">
                                                            <Heading as="h5">Deal Pipeline Stage</Heading>
                                                            <Row gutter={30} style={{ margin: "30px 0px 20px" }}>
                                                                <Col span={24} style={{ marginBottom: 10 }}>
                                                                    <Form.Item name="pipelineStage"
                                                                        id="pipelineStage"
                                                                        rules={edit && editableType ? [{ required: true, message: 'Please select a pipeline stage', }] : [{ required: false }]}>
                                                                        <PipelineStagesArrow
                                                                            stages={pipeLineStage}
                                                                            currentStage={pipelineData}
                                                                            onStageClick={(index, name) => handlePipeLineChange(index, { key: name }, tempWinProp)}
                                                                            completedColor="#007bff"
                                                                            upcomingColor="#e0e0e0"
                                                                            textColor="#fff"
                                                                            arrowHeight={40}
                                                                            notchSize={6}
                                                                            editableType={editableType}
                                                                            edit={edit}
                                                                            displayData={displayData}
                                                                            oldPipeline={oldPipeline}
                                                                            pipeLineStage={pipeLineStage}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            <Heading as="h5">Basic Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Deal Name" name="dealname"
                                                                        id="dealname"
                                                                        rules={[{
                                                                            required: true,
                                                                            transform: (value) => value?.trim(), message: 'Please enter deal name',
                                                                        }, {
                                                                            validator: (_, value) => {
                                                                                const error = nameOnChangeValidator(value, 50);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        }]}
                                                                    ><Input placeholder="Enter Deal Name" />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Deal Owner" name="dealOwner"
                                                                        id="dealOwner"
                                                                        rules={[{ required: true, message: 'Please select a deal owner', }]}>
                                                                        <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Deal Owner"
                                                                            showSearch
                                                                            optionLabelProp="label"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                        >
                                                                            {users}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Account Name" name="accountName"
                                                                        id="accountName" rules={[{ required: true, message: 'Please select an account name', }]}>
                                                                        <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Account Name"
                                                                            showSearch optionLabelProp="label"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                            onChange={(value) => { handleAccountChange(value); onchangeDelete(value) }}
                                                                        >
                                                                            {account.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                                                                                <Option value={option.account_id} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center' }} >
                                                                                        <div className='Div_flex2'>
                                                                                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                    < img src={option.account_profile} alt="profile" />
                                                                                                    :
                                                                                                    <span className="image_icon AccountIcon">
                                                                                                        {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }
                                                                                                <span className='div-ellipsis'>{option.account_name}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                        <div>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                            <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Deal Urgency" name="priority"
                                                                        id="priority"><Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} onChange={(value) => form.setFieldsValue({ priority: value || null })} allowClear placeholder="Select Deal Urgency">
                                                                            {dealPriority}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Deal Type" name="dealType"
                                                                        id="dealType"
                                                                        rules={[{ required: true, message: 'Please select a deal type', }]}
                                                                    >
                                                                        <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Select Deal Type" value={dealTypeData} onChange={handleDealTypeChange}>
                                                                            {dealType.map((option) => (
                                                                                <Option value={option.dealTypeId} key={option.dealTypeName}>
                                                                                    {option.dealTypeName}
                                                                                </Option>))}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Deal SubType" name="typevalue"
                                                                        id="typevalue"
                                                                        rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select a deal sub type', }] : [{ required: false }]}
                                                                    >
                                                                        <Select getPopupContainer={getFieldPopupContainer} disabled={dealTypeField !== "New" && dealTypeField !== "Expansion"} allowClear
                                                                            style={{ width: '100%' }} placeholder="Select Deal SubType" value={typeAction} onChange={handleTypeAction} >
                                                                            <Option value="Request for Proposal">Request for Proposal</Option>
                                                                            <Option value="Staff Augmentation">Staff Augmentation</Option>
                                                                            <Option value="Product and Services">Product and Services</Option>
                                                                            <Option value="Others">Others</Option>
                                                                            {dealTypeField === "Empanelment" && <Option value="Not Applicable">Not Applicable</Option>}
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Competition"
                                                                        name="competition"
                                                                        id="competition"
                                                                    >
                                                                        <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                            placeholder="Select Account Name"
                                                                            showSearch mode="multiple" optionLabelProp="label"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) => {
                                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                    const username = String(usernameElement.props.children);
                                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                                }
                                                                                return false;
                                                                            }
                                                                            }
                                                                        >
                                                                            {accountbyType.filter((item) => item.account_type_name === "Competitor").map((option, i) => (
                                                                                <Option value={option.account_id} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                                                                                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                            < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                        <div>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.account_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                            <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))
                                                                            }
                                                                        </Select>
                                                                    </Form.Item>
                                                                </Col>

                                                                {dealTypeField === "Expansion" ? <>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Parent Deal Name" name="parentDeal"
                                                                            id="parentDeal"
                                                                            rules={dealTypeField === "Expansion" && edit ? [{ required: true, message: 'Please select a parent deal', }] : [{ required: false }]}
                                                                        >
                                                                            <Select getPopupContainer={getFieldPopupContainer} allowClear={dealTypeField !== "Expansion"} optionLabelProp="label"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }
                                                                                style={{ width: '100%' }} placeholder="Select Parent Deal"  >
                                                                                {dealMapList.map((option, i) => (
                                                                                    <Option value={option.deals_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                                                                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                                        < img src={option.deal_profile} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon DealIcon">
                                                                                                            {option.deal_name?.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>)}>
                                                                                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                                                                                            <div>
                                                                                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                                                                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.deal_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                                                                                <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </Col>

                                                                </> : ""}
                                                                {pipeLineField !== "Prospecting" && pipeLineField !== "Qualification" && pipeLineField !== "Discovery" &&
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Commit Status" name="commitstatus" id="commitstatus"
                                                                            rules={(pipeLineField === "Won" || pipeLineField === "Negotiation" && edit) ? [{ required: true, message: 'Please select commit status', }] : [{ required: false }]}
                                                                        > <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} allowClear onChange={(value) => form.setFieldsValue({ commitstatus: value || null })} placeholder="Select Commit Status">
                                                                                <Option value="Hard Commit">Hard Commit</Option>
                                                                                <Option value="Soft Commit">Soft Commit</Option>
                                                                            </Select>
                                                                        </Form.Item>
                                                                    </Col>
                                                                }
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    {/* <Form.Item label="Description" name="dealDescription" id="dealDescription" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = validateDescriptionField(value, 2500);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                        <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                                    </Form.Item> */}
                                                                    <Form.Item label="Description" >
                                                                        <TinyMCEEditor
                                                                            placeholder="Enter Description"
                                                                            content={content1}
                                                                            setContent={handleChange1}
                                                                            edit
                                                                            page="TextBoxs"
                                                                            height={150}
                                                                            selectedEntity="A"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item
                                                                        label="Tags"
                                                                        name="tags"
                                                                        id="tags"
                                                                    >
                                                                        <Select open={false}
                                                                            className="lead-tags-input"
                                                                            mode="tags"
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Enter tags"
                                                                            tokenSeparators={[","]}
                                                                            getPopupContainer={getFieldPopupContainer}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {edit && <>
                                                                <Heading as="h5">Contact Information</Heading>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                                        <Form.Item label="Contact Person" name="contactPerson"
                                                                            id="contactPerson"
                                                                            rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select a contact person', }] : [{ required: false }]}
                                                                        >
                                                                            <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                                placeholder="Select Contact Person"
                                                                                showSearch optionLabelProp="label"
                                                                                mode="multiple"
                                                                                optionFilterProp="children"
                                                                                filterOption={(input, option) => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                }
                                                                                }>
                                                                                {contacts.map((option, i) => (
                                                                                    <Option value={option.contacts_id} key={i} label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                        </div>)} >
                                                                                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                            <div>
                                                                                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.first_name?.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                                <p style={{ margin: 0 }}>{option.email}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                                }
                                                                            </Select>

                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row></>}
                                                            <Heading as="h5">Deal Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Expected Deal Margin" name="dealmargin"
                                                                        id="dealmargin" rules={[
                                                                            {
                                                                                validator: async (_, value) => {
                                                                                    if (value === undefined || value === null || value === '') {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    if (value?.toString()?.length > 25) {
                                                                                        return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                    }
                                                                                    // Strict numeric check (digits with optional 1 dot)
                                                                                    const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                    if (!basicNumberCheck.test(value)) {
                                                                                        return Promise.reject(new Error('Please enter a valid number'));
                                                                                    }

                                                                                    // Check decimal places (must be ≤ 2)
                                                                                    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                    if (!decimalRegex.test(value)) {
                                                                                        return Promise.reject(
                                                                                            new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                        );
                                                                                    }

                                                                                    const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                    if (num < 0 || num > 100) {
                                                                                        return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                }

                                                                            }
                                                                        ]}>
                                                                        {edit || inLineFields.expected_deal_margin ? <Input disabled={pipeLineField === "Won"} prefix="%" placeholder='Enter Expected Deal Margin' onChange={(e) => setChangeDealMargin(e.target.value)} onBlur={(e) => {
                                                                            if (e.target.value === '') {
                                                                                form.setFieldsValue({ dealmargin: 0 });
                                                                                setChangeDealMargin(0);
                                                                            }
                                                                        }} />
                                                                            : <>
                                                                                {canUpdateDelete(permissions, dataPermissions, "Update", 2015) ?
                                                                                    <span className={editableType ? "edit-span text_icon" : ""}>
                                                                                        % {displayData?.expected_deal_length}
                                                                                        {editableType && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("expected_deal_margin")} />
                                                                                        } </span>
                                                                                    : <span className='text_icon'>
                                                                                        % {displayData?.expected_deal_length}
                                                                                    </span>}
                                                                            </>}
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Win Probability" name="winProbability"
                                                                        id="winProbability" rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{
                                                                            required: true,
                                                                            transform: (value) => value?.trim(), message: 'Please enter win probability'
                                                                        }
                                                                            , {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                if (value?.toString()?.length > 25) {
                                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }

                                                                        }
                                                                        ] : [{ required: false }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                if (value?.toString()?.length > 25) {
                                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }

                                                                        }]}>
                                                                        <Input prefix="%" min={0} max={100} value={winProbability} disabled={pipeLineField === "Won" || pipeLineField === "Lost"} placeholder='Enter Win probability'
                                                                            onChange={(e) => setWinProbability(e.target.value)} onBlur={(e) => {
                                                                                if (e.target.value === '') {
                                                                                    form.setFieldsValue({ winProbability: 0 });
                                                                                    setWinProbability(0);
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Forecasted Value (${defaultCurrency?.currency})`} name="forecastedValue" id="forecastedValue">
                                                                        <Input disabled prefix={defaultCurrency?.symbol} />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Expected Closure Date" name="expectedClosureDate"
                                                                        id="expectedClosureDate"
                                                                        rules={pipeLineField !== "Prospecting" && edit ? [{ required: true, message: 'Please select a closure date', }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const startDate = getFieldValue('revenueStartDate');
                                                                                if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                                            },
                                                                        }),] : [{ required: false }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const startDate = getFieldValue('revenueStartDate');
                                                                                if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                                            },
                                                                        }),]}
                                                                    >
                                                                        <DatePicker
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                                            onChange={expectedClosureDateChange}
                                                                            disabledDate={(current) => {
                                                                                const start = revenueStartDate ? moment(revenueStartDate, "YYYY-MM-DD").startOf("day") : null;
                                                                                const end = revenueEndDate ? moment(revenueEndDate, "YYYY-MM-DD").startOf("day") : null;

                                                                                return current && (
                                                                                    current < moment().startOf("day") || // ❌ disallow past
                                                                                    (start && current.isAfter(start, 'day')) || // ❌ disallow after start
                                                                                    (end && current.isAfter(end, 'day')) // ❌ disallow after end
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>


                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Revenue Start date" name="revenueStartDate"
                                                                        id="revenueStartDate" rules={pipeLineField !== "Prospecting" &&
                                                                            dealTypeField !== "Empanelment" &&
                                                                            (edit || editWon) ?
                                                                            [{ required: true, message: 'Please enter revenue start date' },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    const closure = getFieldValue('expectedClosureDate');
                                                                                    const end = getFieldValue('revenueEndDate');

                                                                                    if (!value) return Promise.resolve();

                                                                                    if (closure && value.isBefore(closure, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                                                    }
                                                                                    if (end && value.isAfter(end, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                },
                                                                            }),
                                                                            ] : [{ required: false }, ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    const closure = getFieldValue('expectedClosureDate');
                                                                                    const end = getFieldValue('revenueEndDate');

                                                                                    if (!value) return Promise.resolve();

                                                                                    if (closure && value.isBefore(closure, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                                                    }
                                                                                    if (end && value.isAfter(end, 'day')) {
                                                                                        return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                                                    }

                                                                                    return Promise.resolve();
                                                                                },
                                                                            }),]}>
                                                                        <DatePicker onChange={revenueStartDateChange}
                                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                            disabledDate={(current) => {
                                                                                const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;
                                                                                const end = revenueEndDate ? moment(revenueEndDate, "YYYY-MM-DD").startOf("day") : null;

                                                                                return current && (
                                                                                    current < moment().startOf("day") || // disallow past
                                                                                    (closure && current.isBefore(closure, 'day')) || // ✅ allow same as closure
                                                                                    (end && current.isAfter(end, 'day'))             // ✅ allow same as end
                                                                                );
                                                                            }}
                                                                            disabled={typeAction === "Staff Augmentation"}
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Revenue End Date" name="revenueEndDate"
                                                                        id="revenueEndDate" rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && (edit || editWon) ? [{ required: true, message: 'Please enter revenue end date' },
                                                                        ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const start = getFieldValue('revenueStartDate');
                                                                                if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                                            },
                                                                        }),
                                                                        ] : [{ required: false }, ({ getFieldValue }) => ({
                                                                            validator(_, value) {
                                                                                const start = getFieldValue('revenueStartDate');
                                                                                if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                                            },
                                                                        }),]}>
                                                                        <DatePicker onChange={revenueEndDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={(current) => {
                                                                            const start = revenueStartDate ? moment(revenueStartDate, "YYYY-MM-DD").startOf("day") : null;
                                                                            const closure = expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD").startOf("day") : null;

                                                                            return current && (
                                                                                current < moment().startOf("day") || // ❌ disallow past
                                                                                (start && current.isBefore(start, 'day')) || // ❌ disallow before start
                                                                                (closure && current.isBefore(closure, 'day')) // ❌ disallow before closure
                                                                            );
                                                                        }} disabled={typeAction === "Staff Augmentation"} />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label={`Gross Deal Value (${defaultCurrency?.currency})`} name="grossdealValue" id="grossdealValue"
                                                                        rules={pipeLineField !== "Prospecting" && dealTypeField !== "Empanelment" && edit ? [{
                                                                            required: true,
                                                                            transform: (value) => value?.trim(), message: 'Please enter gross deal value'
                                                                        }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                if (value?.toString()?.length > 25) {
                                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }
                                                                            }
                                                                        }] : [{ required: false }, {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                if (value?.toString()?.length > 25) {
                                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }
                                                                            }
                                                                        }]}
                                                                    >
                                                                        <Input
                                                                            placeholder='Enter Gross Deal Value'
                                                                            prefix={defaultCurrency?.symbol}
                                                                            min={0}
                                                                            // allowClear
                                                                            disabled={((typeAction !== "Request for Proposal" && typeAction !== "Others") || dealValueEdit === "Disabled")}
                                                                            onChange={(e) => OndealvalueChange(e.target.value)} />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label="Discount Percentage" name="discountvalue" id="discountvalue" rules={[
                                                                        {
                                                                            validator: async (_, value) => {
                                                                                if (value === undefined || value === null || value === '') {
                                                                                    return Promise.resolve();
                                                                                }
                                                                                if (value?.toString()?.length > 25) {
                                                                                    return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                }
                                                                                // Strict numeric check (digits with optional 1 dot)
                                                                                const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                if (!basicNumberCheck.test(value)) {
                                                                                    return Promise.reject(new Error('Please enter a valid number'));
                                                                                }

                                                                                // Check decimal places (must be ≤ 2)
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (!decimalRegex.test(value)) {
                                                                                    return Promise.reject(
                                                                                        new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                    );
                                                                                }

                                                                                const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                if (num < 0 || num > 100) {
                                                                                    return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }

                                                                        }
                                                                    ]}>
                                                                        <Input prefix="%" placeholder='Enter Discount Percentage' value={dealDiscount}
                                                                            onChange={(e) => setDealDiscount(e.target.value)} onBlur={(e) => {
                                                                                if (e.target.value === '') {
                                                                                    form.setFieldsValue({ discountvalue: 0 });
                                                                                    setDealDiscount(0);
                                                                                }
                                                                            }} />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label={`Deal Value (${defaultCurrency?.currency})`} name="dealValue" id="dealValue" rules={[
                                                                        {
                                                                            pattern: /^\d+(\.\d+)?$/,
                                                                            message: 'Please enter a valid deal value',
                                                                        },
                                                                    ]}>
                                                                        <Input
                                                                            pattern="^\d+(\.\d+)?$"
                                                                            placeholder='Enter Deal Value'
                                                                            prefix={defaultCurrency?.symbol}
                                                                            disabled />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={8} style={{ marginBottom: 20 }} >
                                                                    <Form.Item label={`Deal Profit (${defaultCurrency?.currency})`} name="dealprofit" id="dealprofit" rules={[
                                                                        {
                                                                            pattern: /^\d+(\.\d+)?$/,
                                                                            message: 'Please enter a valid deal profit',
                                                                        },
                                                                    ]}>
                                                                        <Input
                                                                            pattern="^\d+(\.\d+)?$"
                                                                            placeholder='Deal Value'
                                                                            prefix={defaultCurrency?.symbol}
                                                                            disabled />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {(pipeLineField === "On-Hold" || pipeLineField === "Won" || pipeLineField === "Lost" || pipeLineField === "on-Hold") ? <>
                                                                <Heading as="h5">Deal {pipeLineField} Information</Heading>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    {pipeLineField === "Won" && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Actual Closure Date" name="actualclosureDate"
                                                                                id="actualclosureDate"
                                                                                rules={pipeLineField === "Won" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select actual closure date', }] : [{ required: false }]}
                                                                            >
                                                                                <DatePicker onChange={actualclosuredateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Actual Deal Margin" name="actualdealmargin"
                                                                                id="actualdealmargin" rules={pipeLineField === "Won" && dealTypeField !== "Empanelment" && edit ? [{
                                                                                    required: true,
                                                                                    transform: (value) => value?.trim(), message: 'Please select actual deal margin'
                                                                                }, {
                                                                                    validator: async (_, value) => {
                                                                                        if (value === undefined || value === null || value === '') {
                                                                                            return Promise.resolve();
                                                                                        }
                                                                                        if (value?.toString()?.length > 25) {
                                                                                            return Promise.reject(new Error('Maximum 25 characters allowed'));
                                                                                        }
                                                                                        // Strict numeric check (digits with optional 1 dot)
                                                                                        const basicNumberCheck = /^\d+(\.\d*)?$/;
                                                                                        if (!basicNumberCheck.test(value)) {
                                                                                            return Promise.reject(new Error('Please enter a valid number'));
                                                                                        }

                                                                                        // Check decimal places (must be ≤ 2)
                                                                                        const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                        if (!decimalRegex.test(value)) {
                                                                                            return Promise.reject(
                                                                                                new Error(`Only up to ${CurencyDecimalPlace} decimal place${CurencyDecimalPlace > 1 ? 's' : ''} are allowed`)
                                                                                            );
                                                                                        }

                                                                                        const num = Number(value); // Now it's guaranteed to be a proper number

                                                                                        if (num < 0 || num > 100) {
                                                                                            return Promise.reject(new Error('Percentage must be between 0 and 100'));
                                                                                        }

                                                                                        return Promise.resolve();
                                                                                    }

                                                                                }] : [{ required: false }]}>
                                                                                <Input pattern="^\d+(\.\d+)?$" placeholder='Enter Actual Deal Margin' prefix="%" onChange={(e) => setChangeDealMargin2(e.target.value)} />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal Won Reason" name="dealWonreasons"
                                                                                id="dealWonreasons"
                                                                            >
                                                                                <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Select Deal Won Reasons" onChange={(value) => form.setFieldsValue({ dealWonreasons: value || null })} allowClear>
                                                                                    {dealWon}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                    {pipeLineField === "Lost" && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal Lost Date" name="dealLostDate"
                                                                                id="dealLostDate"
                                                                                rules={pipeLineField === "Lost" && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select deal lost date', }] : [{ required: false }]}>
                                                                                <DatePicker
                                                                                    onChange={dealLostDateChange}
                                                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                    disabledDate={disabledDate}
                                                                                />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal Lost Reason" name="deallostReasons" id="deallostReasons" >
                                                                                <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} onChange={(value) => form.setFieldsValue({ deallostReasons: value || null })} placeholder="Select Deal Lost Reasons" allowClear>
                                                                                    {dealLose}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                    {(pipeLineField === "on-Hold" || pipeLineField === "On-Hold") && <>
                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal On-Hold Date" name="dealonholdDate"
                                                                                id="dealonholdDate"
                                                                                rules={(pipeLineField === "on-Hold" || pipeLineField === "On-Hold") && dealTypeField !== "Empanelment" && edit ? [{ required: true, message: 'Please select deal On-Hold date', }] : [{ required: false }]}>
                                                                                <DatePicker onChange={dealonholdDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal Restart Date" name="dealrestartDate"
                                                                                id="dealrestartDate" rules={[
                                                                                    ({ getFieldValue }) => ({
                                                                                        validator(_, value) {
                                                                                            const dealonholdDate = getFieldValue('dealonholdDate');

                                                                                            if (!value || !dealonholdDate || value >= dealonholdDate) {
                                                                                                return Promise.resolve();
                                                                                            }

                                                                                            return Promise.reject(new Error('Deal Restart Date must be after Deal onhold Date'));
                                                                                        },
                                                                                    }),]}>
                                                                                <DatePicker onChange={dealrestartDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} />
                                                                            </Form.Item>
                                                                        </Col>

                                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                                            <Form.Item label="Deal On-Hold Reason" name="dealonHoldReason" id="dealonHoldReason" >
                                                                                <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} placeholder="Select Deal On-Hold Reasons" onChange={(value) => form.setFieldsValue({ dealonHoldReason: value || null })} allowClear>
                                                                                    {dealOnHold}
                                                                                </Select>
                                                                            </Form.Item>
                                                                        </Col>
                                                                    </>}
                                                                </Row>
                                                            </> : <></>}
                                                            {typeAction === "Staff Augmentation" ? <>
                                                                {(roleData.length > 0 || edit) &&
                                                                    <div style={{ display: 'flex' }}>
                                                                        <Heading as="h5">{!edit ? "Role Details" : "Add Roles"}</Heading>
                                                                        {/* {roleData.length === 0 && (revenueStartDate === null || revenueEndDate == null) && <span style={{ color: "red", margin: "1px 10px 0px" }}>* Please, Add Roles for Revenue start and End Date</span>} */}
                                                                    </div>}
                                                                {roleData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Deal-RoleTable'}`}>
                                                                                <Table
                                                                                    dataSource={roleData}
                                                                                    columns={StaffColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Staff Augmentation"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRoles}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(formDatas.length > 0 || edit) && <Heading as="h5">{!edit ? "Product Details" : "Add Products"}</Heading>}
                                                                {formDatas.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Product-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={formDatas}
                                                                                    columns={ProductColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row> : <Row >{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Product"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewRow}
                                                                        />} </Row>}
                                                            </> : <></>}
                                                            {typeAction === "Product and Services" || typeAction === "Request for Proposal" ? <>
                                                                {(servicesData.length > 0 || edit) && <Heading as="h5">{!edit ? "Service Details" : "Add Services"}</Heading>}
                                                                {servicesData.length ?
                                                                    <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                        <Col span={24} style={{ marginBottom: 20 }}>
                                                                            <div className={`table-bordered leaderboard-table table-responsive ${edit && 'Service-DealTable'}`}>
                                                                                <Table
                                                                                    dataSource={servicesData}
                                                                                    columns={ServicesColumns}
                                                                                    rowKey={(record, index) => index?.toString()}
                                                                                    pagination={false}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    : <Row>{edit &&
                                                                        <PlusCircleOutlined
                                                                            title="Add New Services"
                                                                            style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "30px 0px" }}
                                                                            onClick={addNewSerivce}
                                                                        />}</Row>}
                                                            </> : <></>}
                                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                            <Heading as="h5">Profile Picture</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <figure className="photoUpload align-center-v" >
                                                                        {image !== null && image !== undefined && image !== "" ?
                                                                            < img src={image} alt="" />
                                                                            :
                                                                            UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" ?
                                                                                <span className='details_span_Tag DealIcon'>
                                                                                    {displayData?.deal_name?.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                                :
                                                                                <span className='details_span_Tag DealIcon'>
                                                                                    D
                                                                                </span>}
                                                                        {edit && !imageUploading && <figcaption>
                                                                            {deleteOption ? (
                                                                                <div className='delete-div'>
                                                                                    <span className='delete-span'>
                                                                                        <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                    </span>
                                                                                </div>) :
                                                                                (<div><ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image" beforeCrop={(file) => {
                                                                                    const allowedTypes = [
                                                                                        'image/png',
                                                                                        'image/jpeg',
                                                                                    ];

                                                                                    if (!allowedTypes.includes(file.type)) {
                                                                                        message.error('Only PNG, JPG and JPEG images are allowed');
                                                                                        return false;
                                                                                    }

                                                                                    return true;
                                                                                }}>
                                                                                    <Upload {...FileUpload}>
                                                                                        <Link className="btn-upload" to={combinedUrl}>
                                                                                            <FeatherIcon icon="camera" size={16} />
                                                                                        </Link>
                                                                                    </Upload></ImgCrop>
                                                                                </div>)
                                                                            }
                                                                        </figcaption>
                                                                        }
                                                                    </figure>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </VerticalFormStyleWrap>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> : <div className="spin">
                    <Spin />
                </div>}
            </Drawer >
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;